<template>
  <transition
    leave-class="hidden"
    enter-active-class="animated bounceIn"
  >
    <q-banner
      v-if="shown"
      class="bg-negative full-width text-white"
      :dense="dense"
      data-test-id="model-error-banner"
    >
      <template #avatar>
        <q-icon
          class="q-mr-sm"
          size="md"
          name="error"
          color="white"
        />
      </template>
      <slot>
        Errors exist below, cannot proceed.
      </slot>
    </q-banner>
  </transition>
</template>

<script>
export default {
  name: 'ModelErrorBanner',
  props: {
    shown: {
      type: Boolean,
      required: false,
      default: false
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
